import { render } from "./PetitionsCalendar.vue?vue&type=template&id=3ed3df86"
import script from "./PetitionsCalendar.vue?vue&type=script&lang=js"
export * from "./PetitionsCalendar.vue?vue&type=script&lang=js"

import "./PetitionsCalendar.vue?vue&type=style&index=0&id=3ed3df86&lang=css"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__